import React, { useEffect } from 'react'
import Aos from 'aos';
import 'aos/dist/aos.css';

const CardExperience = (props) => {

  //Animation
  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: false,
  });
  },[]);

  return (
    <>
        <div data-aos="flip-left" className='box btn_shadow'>
            <div className='title__content'>
                <div className='title'>
                    <h3>{props.title}</h3>
                    <span>{props.year}</span>
                </div>
                
            </div>
            <hr />
            <p>{props.desc1}</p>
            <p>{props.desc2}</p>
            <p>{props.desc3}</p>
            <p>{props.desc4}</p>
            <p>{props.desc5}</p>
        
      </div>
    </>
  )
}

export default CardExperience